import {api} from "../../shared/utils";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients
const emptyPaginatedResponse = Promise.resolve({
    data: {
        valor: {
            items: [],
            pagination: {
                page: 1,
                page_size: 10,
                total: 0,
                total_pages: 0,
                has_next: false,
                has_previous: false,
            },
        },
    },
});

export const getEmpresas = () => environment.disableAuth ? emptyPaginatedResponse : api.get(`${baseUrl}/empresas`);
export const getEmpresasFiltered = ({page, pageSize, filter, sortBy, order}) => {
    if (environment.disableAuth) return emptyPaginatedResponse;

    const params = new URLSearchParams();
    if (page) params.set('page', page);
    if (pageSize) params.set('pageSize', pageSize);
    if (filter) params.set('q', filter);
    if (sortBy) params.set('sortBy', sortBy);
    if (order) params.set('order', order);
    const url = `${baseUrl}/empresas${params.toString() ? `?${params.toString()}` : ''}`;
    return api.get(url);
};
export const getEmpresa = (id) => environment.disableAuth ? Promise.resolve({data: {valor: null}}) : api.get(`${baseUrl}/empresas/${id}`);
export const createEmpresa = (empresa) => environment.disableAuth ? Promise.resolve({data: {valor: empresa}}) : api.post(`${baseUrl}/empresas`, empresa);
export const updateEmpresa = (id, empresa) => environment.disableAuth ? Promise.resolve({data: {valor: {...empresa, id}}}) : api.put(`${baseUrl}/empresas/${id}`, empresa);
export const deleteEmpresa = (id) => environment.disableAuth ? Promise.resolve({data: {valor: id}}) : api.delete(`${baseUrl}/empresas/${id}`);

// As assinaturas da empresa (app-licencas): a lista inteira, sem paginação.
export const getLicencasDaEmpresa = (id) => environment.disableAuth
    ? Promise.resolve({data: {data: []}})
    : api.get(`${baseUrl}/licencas/empresa/${id}`);

// A próxima fatura da empresa, pelo mesmo cálculo da emissão (BBF-24). Só lê: nada é gravado.
export const getPreviaDaEmpresa = (id) => environment.disableAuth
    ? Promise.resolve({data: {data: null}})
    : api.get(`${baseUrl}/financeiro/empresas/${id}/previa`);
